import { render, staticRenderFns } from "./AlertCommentBox.vue?vue&type=template&id=03957f85&scoped=true&"
import script from "./AlertCommentBox.vue?vue&type=script&lang=js&"
export * from "./AlertCommentBox.vue?vue&type=script&lang=js&"
import style0 from "./AlertCommentBox.vue?vue&type=style&index=0&id=03957f85&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03957f85",
  null
  
)

export default component.exports